export default "__VITE_ASSET__B$RIIK9F__"